export default {
  server_URL: 'https://api.darlingreversemortgage.com',
  loanOfficerUID: 'r81stwhkuj'
};
